<template>
  <div>
    <!-- Map Area Starts -->
    <section class="map-area section-padding news_section1 section">
      <div class="banner-sun">
        <p class="p1 animate fadeInDown animated news_sun_ziti1"
          style="animation-duration: 0.7s; animation-delay: 0.1s; visibility: visible;">新闻中心</p>
        <p class="p2 animate zoomIn animated news_sun_ziti2"
          style="animation-duration: 0.7s; animation-delay: 1s; visibility: visible; color: red;">NEWS</p>
        <!-- <P class="p3 animate fadeInUp animated news_sun_ziti3" style="animation-duration: 0.7s; animation-delay: 0.3s; visibility: visible;">烟台拿度智能科技有限公司</P> -->
        <!-- <P class="p3 animate fadeInUp animated news_sun_ziti4" style="animation-duration: 1s; animation-delay: 1.5s; visibility: visible; color: rgb(228 2 48);font-weight: bold;font-size: 40px; ">
					  {{newtitle}}
				  </P> -->
      </div>

    </section>
    <!-- Map Area End -->
    <!-- Start blog-posts Area  style=" background: #f7f8fa;" -->
    <section class="blog-posts-area section-padding">
      <div class="container xinwen2912">
        <div class="row buxianshi">
          <div class="swiper-container" style="width: 100%; margin: 50px 0px;">
            <div class="swiper-wrapper" style="width: 100%;">

              <div v-for="(item, index) in newslunbo" :key="index" class="swiper-slide"
                style="width: 100%;height: 450px;">
                <a :href="'/blogDetails?id=' + item.id + '&cid=' + thisid" style="color: black;">
                  <div style="width: 50%;height: 400px;float: left;">
                    <div class="beijingyangshi"
                      :style="'background: url(' + newurl + item.ico + ')no-repeat center center; width: 100%;height:100%;'">
                    </div>
                  </div>
                  <div style="width: 50%;height: 400px;float: right; background: #ffffff;">
                    <div style="width: 100%; padding: 30px; line-height: 40px;">
                      <h4 style="line-height: 60px;font-size:16px;">{{ item.title }}</h4>
                      <p>{{ item.description }}</p>
                      <p>{{ item.date }} <span style="float: right;">阅读全文 ></span></p>
                    </div>
                  </div>
                </a>
              </div>


            </div>
            <div class="swiper-pagination"> </div>
          </div>
        </div>
        <div class="chanpin_s2">

          <div v-for="(item, index) in newslist" :key="index" class="chanpin_s1_02 chanpin_s1_02_xin  animate zoomIn animated"
            style="animation-duration: 1s; animation-delay: 1s;">
            <a :href="'/blogDetails?id=' + item.id + '&cid=' + thisid" style="color: black;">
              <div class="chanpin_s101_a" style="border-radius:0px;border: 0px">
                <div
                  :style="'background: url(' + newurl + item.ico + ')no-repeat center center;background-size: cover !important;width: 100%;height: 200px;'">
                </div>
                <div class="xinwen912" style="height: 150px;width: 100%;background: #ffffff;padding: 30px;">
                  <h4 class="zitikaka" style="font-size:16px;">{{ truncatechanpinzzz(item.title) }}</h4>
                  <br>
                  <p><span style="float: right;">阅读全文 > </span></p>
                </div>
              </div>
            </a>
          </div>

          <div class="donghuaRight"
            style="width: 100%;height: 30px;text-align: center; line-height: 100px; animation-duration: 1s; animation-delay: 0.6s;margin-top: 100px;">
            <!-- <a :href="'/blog?id='+thisid" target="_blank"> -->
              <div class="download-btn" @click="jiazai(numzong)">
                查看更多{{ newtitle }} +
              </div>
          </div>

        </div>
      </div>
    </section>
    <!-- End blog-posts Area -->
  </div>
</template>

<style>
body {
  background-color: #f7f8fa;
}

/* 自定义Swiper的分页器样式 */
.swiper-pagination-bullet {
  width: 30px;
  /* 设置正方形的宽度 */
  height: 4px;
  /* 设置正方形的高度，与宽度相同即为正方形 */
  background-color: #cccccc;
  /* 设置正方形的背景颜色 */
  /* 以下属性为可选，根据你的需求进行调整 */
  opacity: 0.8;
  /* 设置透明度 */
  border-radius: 0;
  /* 移除默认的圆角，因为正方形不需要圆角 */
  margin: 0 5px;
  /* 分页器之间的间隔 */
}

/* 当前活动分页器（即当前显示的slide对应的分页器）的样式 */
.swiper-pagination-bullet-active {
  background-color: #ff9800;
  /* 当前活动分页器的背景颜色 */
  opacity: 1;
  /* 当前活动分页器的透明度 */
}
</style>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      newtitle: '',
      newslist: [],
      newslunbo: [
        {
          id: '',
          ico: '',
          date: '',
          title: '',
          description: '',
        },
        {
          id: '',
          ico: '',
          date: '',
          title: '',
          description: '',
        },
        {
          id: '',
          ico: '',
          date: '',
          title: '',
          description: '',
        },
      ],
      numzong:6,
      qiyeinfo: [],
      zhandianinfo: [],
      daohanglist: [],
      messtel: '',
      messname: '',
      messtitle: '',
      thisid: '',
      newurl: 'https://naduapi.jurenkeji.com.cn',
    };
  },
  mounted() {
    // 获取当前id
    this.thisid = this.$route.query.id;
    if (this.thisid == 15) {
      this.newtitle = '新闻';
    } else {
      this.newtitle = '技术文章';
    }



    //公司信息
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/company', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.qiyeinfo = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });

    //站点信息
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/site', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.zhandianinfo = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });

    //导航数据
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/nav', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.daohanglist = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });
    //新闻列表滚动
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/xwttlist/num/' + this.thisid, {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.newslunbo = response.data.data;
      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });
    //新闻列表list
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/' + this.thisid + '/num/'+this.numzong+'/order/sorting', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.newslist = response.data.data;
      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });

  },
  methods: {
     // 截取产品中心产品标题指定长度
     truncatechanpinzzz(dateStr, length = 18) {
          return dateStr.substring(0, length) + '...';
    },
    jiazai(num){
      let zong = num+3;
      if(this.newslist.length < num){
        console.log(this.newslist.length,num)
        alert('已经没有更多' + this.newtitle + '!');
      }else{


      this.numzong = zong;
      
          //新闻列表list
      axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/' + this.thisid + '/num/'+zong+'/order/sorting', {
        appid: 'jurenkeji2024',
        timestamp: '1722845854',
        signature: '0eb76b812e96966c380b90c6e7416a26'
      })
        .then(response => {
          // console.log(response.data.data);
          this.newslist = response.data.data;
        })
        .catch(error => {
          console.error('当前网络环境异常!', error);
        });
    }

    }

  }
};
</script>
<style>
.beijingyangshi {
  background-size: cover !important;
}
</style>






// WEBPACK FOOTER //
// BlogHome.vue?066548ba